import { TodayCounter } from './analytics.schema';

export function getDatestamp(purchaseTime: number): number {
  // Day change at 3am
  return Math.floor(
    (purchaseTime - 3 * 60 * 60 * 1000) / (24 * 60 * 60 * 1000),
  );
}
